export var Product;
(function (Product) {
    Product["LogAnalytics"] = "LOG_ANALYTICS";
    Product["Metrics"] = "METRICS";
    Product["Siem"] = "SIEM";
    Product["Tracing"] = "TRACING";
    Product["OrionIQ"] = "ORION_IQ";
})(Product || (Product = {}));
export var ObservabilityProduct;
(function (ObservabilityProduct) {
    ObservabilityProduct["K8S360"] = "K8S360";
    ObservabilityProduct["APP360"] = "APP360";
})(ObservabilityProduct || (ObservabilityProduct = {}));
//# sourceMappingURL=product.enum.js.map